export default "__VITE_ASSET__Cqi81Su1__"